module.exports = __webpack_public_path__ + "static/media/smartphones3.e09ef4a0.png";